import { Link, useLocation } from 'react-router-dom'

const nav = [
  { to: '/', label: '首页' },
  { to: '/wizard', label: '智能引导' },
  { to: '/deploy', label: '部署专区' },
  { to: '/channels', label: '通道对接' },
  { to: '/skills', label: '技能市场' },
  { to: '/sec-fix', label: '安全与排障' },
  { to: '/enterprise', label: '企业解决方案' },
  { to: '/community', label: '玩家社区' },
]

export function Layout({ children }: { children: React.ReactNode }) {
  const loc = useLocation()
  return (
    <>
      <header className="site-header">
        <div className="header-inner">
          <Link to="/" className="logo">
            OpenClaw Hub
          </Link>
          <nav className="nav" aria-label="主导航">
            {nav.map(({ to, label }) => (
              <Link
                key={to}
                to={to}
                className={loc.pathname === to ? 'active' : ''}
              >
                {label}
              </Link>
            ))}
          </nav>
        </div>
      </header>
      <main className="main">{children}</main>
      <footer className="site-footer">
        <div className="footer-inner">
          <div>
            <div className="ready-block">
              企业上门部署解决方案
            </div>
            <Link to="/enterprise" className="cta-btn">
              了解详情
            </Link>
          </div>
          <div className="muted">
            OpenClaw Hub · 全网最全安装部署与生态指南。配置生成均在本地完成，不上传任何 API Key。
          </div>
        </div>
      </footer>
    </>
  )
}
